import { POLICY_STATUSES } from '@buddy-technology/ion-helpers';
import { POLICY_TYPE, WHO_TYPE } from '../models/SimpleModels';
import PolicyHelper from './PolicyHelper';

const CustomerHelper = {
	getWorkingPolicy: (policies = []) => {
		// grab any active policies (should only be one) while controlling for kids only.
		const activePolicy = policies.filter(
			(policy) => policy.status === POLICY_STATUSES.ACTIVE
				&& policy?.who !== WHO_TYPE.KIDS?.value,
		);
		if (activePolicy.length) {
			return activePolicy[0];
		}
		// if no active polices look for upcoming policies
		const upcomingPolicies = policies.filter(
			(policy) => [POLICY_STATUSES.NOT_STARTED, POLICY_STATUSES.RESERVATION].includes(
				policy.status,
			)
				&& policy.who !== WHO_TYPE.KIDS?.value
				&& policy.offering === POLICY_TYPE.ACCIDENT,
		);
		if (upcomingPolicies.length) {
			// find the closest upcoming policy
			upcomingPolicies.sort((a, b) => (a.startDateMillisecond < b.startDateMillisecond ? -1 : 1));
			return upcomingPolicies[0];
		}

		const expiredPolicies = policies.filter(
			(policy) => [
				POLICY_STATUSES.EXPIRED,
				POLICY_STATUSES.CANCELLED,
				POLICY_STATUSES.CANCELLED_RESERVATION,
			].includes(policy.status)
				&& policy.who !== WHO_TYPE.KIDS?.value
				&& policy.offering === POLICY_TYPE.ACCIDENT,
		);
		if (expiredPolicies.length) {
			// find the closest upcoming policy
			expiredPolicies.sort((a, b) => (a.endDateMillisecond > b.endDateMillisecond ? -1 : 1));
			return expiredPolicies[0];
		}
		return null;
	},

	isCurrentlyCovered: (customer) => Boolean(
		customer?.policies?.find(
			(policy) => policy.status === POLICY_STATUSES.ACTIVE,
		),
	),

	isOrWillBeCovered: (customer) => Boolean(
		customer?.policies?.find(
			(policy) => [
				POLICY_STATUSES.ACTIVE,
				POLICY_STATUSES.RESERVATION,
				POLICY_STATUSES.NOT_STARTED,
			].includes(policy.status) && policy.offering === POLICY_TYPE.ACCIDENT,
		),
	),

	isAVigilanceCustomer: (customer) => Boolean(customer?.policies?.some(
		(policy) => PolicyHelper.isVigilancePolicy(policy.offering),
	)),

	// The code below is odd, but it ensures that ONLY POMI policies are present, otherwise it returns false.
	hasOnlyPomiPolicies: (customer) => Boolean(customer?.policies?.length
		&& !(customer?.policies?.some(({ offering }) => !PolicyHelper.isPomiPolicy(offering)))),

	getActivePolicies: (customer) => customer?.policies?.filter((policy) => policy.status === 'ACTIVE') || [],

	getUpcomingPolicies: (customer) => customer?.policies?.filter(
		(policy) => policy.status === POLICY_STATUSES.NOT_STARTED || policy.status === POLICY_STATUSES.RESERVATION,
	) || [],

	getExpiredPolicies: (customer) => customer?.policies?.filter((policy) => [
		POLICY_STATUSES.EXPIRED,
		POLICY_STATUSES.CANCELLED,
		POLICY_STATUSES.CANCELLED_RESERVATION,
	].includes(policy.status)) || [],
};

export default CustomerHelper;
